/**
 * 账户报表定时任务配置（后台可改）
 */
import request from '@/utils/request'

/** 手动拉取、定时拉取可能较慢，延长超时 */
const REPORT_SCHEDULE_TIMEOUT = 120000

export function getAccountReportScheduleConfig() {
  return request({
    url: '/api/config/bidding-account-report-schedule',
    method: 'get',
    timeout: 100000
  })
}

export function saveAccountReportScheduleConfig(data) {
  return request({
    url: '/api/config/bidding-account-report-schedule',
    method: 'put',
    data,
    timeout: 100000
  })
}

/** 手动触发账户报表拉取；data: { managerAccountId?, onlyWithSpending?: true } */
export function triggerAccountReportSync(data = {}) {
  return request({
    url: '/api/config/bidding-account-report-schedule/trigger',
    method: 'post',
    data,
    timeout: REPORT_SCHEDULE_TIMEOUT
  })
}

/** 异步触发拉取任务，立即返回 taskId */
export function triggerAccountReportSyncAsync(data = {}) {
  return request({
    url: '/api/config/bidding-account-report-schedule/trigger-async',
    method: 'post',
    data,
    timeout: 15000
  })
}

/** 查询异步拉取任务状态 */
export function getAccountReportSyncTaskStatus(taskId) {
  return request({
    url: `/api/config/bidding-account-report-schedule/trigger-task/${taskId}`,
    method: 'get',
    timeout: 15000
  })
}

/**
 * 历史数据拉取：按时间类型（日/小时）与日期区间逐天/逐小时拉取，执行日志写入 schedule_job_log。
 * data: { timeType: 'day'|'hour', startDate, endDate, managerAccountId }
 * 返回 { taskId }，轮询 getAccountReportSyncTaskStatus(taskId)；完成后可查看执行日志（scheduleJobLogId）。
 */
export function triggerHistoryPullAsync(data = {}) {
  return request({
    url: '/api/config/bidding-account-report-schedule/history-pull-async',
    method: 'post',
    data,
    timeout: 15000
  })
}

/** 拉取日志分页 */
export function getSyncLogs(params) {
  return request({
    url: '/api/config/bidding-account-report-schedule/logs',
    method: 'get',
    params,
    timeout: 100000
  })
}

/** 账户报表定时(小时) 配置 */
export function getAccountReportHourScheduleConfig() {
  return request({
    url: '/api/config/bidding-account-report-hour-schedule',
    method: 'get',
    timeout: 10000
  })
}

export function saveAccountReportHourScheduleConfig(data) {
  return request({
    url: '/api/config/bidding-account-report-hour-schedule',
    method: 'put',
    data,
    timeout: 10000
  })
}
